import { ComponentProps } from 'react';

import {
  Box,
  HStack,
  IconButton as UclIconButton,
  Input as UclInput,
} from '@rbilabs/universal-components';

import { getDesignToken } from 'styles/constants';
export const Wrapper = HStack.withConfig({
  alignItems: 'center',
});

export const Input = UclInput.withConfig<{ $isHidden?: boolean }>(p => ({
  height: 12,
  width: 12,
  display: p.$isHidden ? 'none' : 'flex',
  margin: 0,
  borderWidth: getDesignToken('border-width-input'),
  borderRadius: getDesignToken('border-radius-input'),
  borderColor: 'transparent',
  backgroundColor: getDesignToken('background-input'),
  textAlign: 'center',
  color: getDesignToken('text-default'),

  _focus: {
    borderColor: getDesignToken('border-color-input'),
  },

  _disabled: {
    borderColor: 'transparent',
    color: getDesignToken('text-disabled'),
  },
}));

export const DisplayedValue = Box.withConfig<{
  $width?: string;
  $disabled?: boolean;
  $overrides?: ComponentProps<typeof Box>;
}>(p => ({
  minHeight: 12,
  minWidth: p.$width,
  maxWidth: 20,
  backgroundColor: getDesignToken('background-input'),
  marginX: 2,
  marginY: 0,
  alignItems: 'center',
  justifyContent: 'center',
  color: p.$disabled ? getDesignToken('text-disabled') : getDesignToken('text-default'),
  _text: {
    ellipsizeMode: 'tail',
    numberOfLines: 1,
    marginX: 2,
  },
  focusable: true,
  ...p.$overrides,
}));

export const IconButton = UclIconButton.withConfig<{
  disabled?: boolean;
  $overrides?: ComponentProps<typeof UclIconButton>;
}>(p => ({
  marginX: -3,
  _icon: {
    color: p.disabled ? getDesignToken('icon-disabled') : getDesignToken('icon-default'),
  },
  _pressed: {
    // Avoid overlapping with numeric input while pressed
    zIndex: 1,
  },
  ...p.$overrides,
}));
